// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'primary', 'primary Fallback'"},"className":"__className_e3a6fd","variable":"__variable_e3a6fd"};